export default __webpack_public_path__ + "static/media/white.41677f00.png";